import React from "react"
import PropTypes from "prop-types"
import StyledMaterialUIAutocomplete from "components/Autocomplete/StyledMaterialUIAutocomplete"
import classNames from "classnames"

const defaultDataSourceConfig = { value: "value", text: "text" }
const noop = () => {}

const Autocomplete = ({
  className,
  containerClassName,
  multiple,
  disabled,
  error,
  dataSourceConfig = defaultDataSourceConfig,
  showClearButton = true,
  onInput = noop,
  ...autocompleteProps
}) => {
  return (
    <div
      className={classNames(
        containerClassName,
        "jass-autocomplete",
        "new-jass-autocomplete",
        `${className}-container`,
        "fieldContainer",
        {
          "jass-multiple-autocomplete": multiple
        }
      )}
    >
      <StyledMaterialUIAutocomplete
        {...autocompleteProps}
        dataSourceConfig={dataSourceConfig}
        showClearButton={showClearButton}
        onInput={onInput}
        className={className}
        isDisabled={disabled}
        isMulti={multiple}
        error={!!error}
      />
    </div>
  )
}

Autocomplete.propTypes = {
  initialValue: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.any,
  showClearButton: PropTypes.bool,
  onInput: PropTypes.func,
  onChange: PropTypes.func.isRequired
}

export default Autocomplete
